import React from 'react'
import PropTypes from 'prop-types'
import { Steps as AntDSteps } from 'antd'
import withStyles from './Steps.style'

const Steps = ({
  className,
  currentStep,
  steps,
  direction,
  labelPlacement,
  size,
  status,
}) => (
  <AntDSteps
    current={currentStep}
    direction={direction}
    labelPlacement={labelPlacement}
    size={size}
    status={status}
    className={className}
  >
    {steps.map(
      (
        {
          key,
          title,
          description,
          status: stepStatus,
          icon,
          onClick,
          disabled,
        },
        index
      ) => (
        <AntDSteps.Step
          // eslint-disable-next-line react/no-array-index-key
          key={`step-${key}${stepStatus}${icon}-${index}`}
          title={title}
          description={description}
          status={stepStatus}
          onClick={disabled ? undefined : onClick}
          icon={icon}
          aria-disabled={disabled || undefined}
        />
      )
    )}
  </AntDSteps>
)

Steps.defaultProps = {
  currentStep: 0,
  direction: 'horizontal',
  labelPlacement: 'horizontal',
  size: 'default',
  status: 'process',
}

Steps.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      status: PropTypes.string,
      onClick: PropTypes.func,
      icon: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  labelPlacement: PropTypes.oneOf(['horizontal', 'vertical']),
  size: PropTypes.oneOf(['default', 'small']),
  status: PropTypes.oneOf(['wait', 'process', 'finish', 'error']),
  className: PropTypes.string,
}

export default withStyles(Steps)
